import React from 'react'
import { clsx } from 'clsx'

interface SanityTableRow {
  _key: string
  cells: string[]
}

interface SanityTableProps {
  value: {
    table?: {
      rows?: SanityTableRow[]
    }
    caption?: string
  }
}

export default function SanityTable({ value }: SanityTableProps) {
  const { table, caption } = value

  if (!table?.rows || table.rows.length === 0) {
    return null
  }

  const [headerRow, ...dataRows] = table.rows

  return (
    <div className="my-7 w-full overflow-x-auto text-[#94a3b8]">
      {caption && (
        <div className="mb-4 text-center text-sm leading-6">{caption}</div>
      )}
      <table className="w-full border-collapse text-sm leading-6">
        {headerRow && (
          <thead>
            <tr className="">
              {headerRow.cells.map((cell, index) => (
                <th
                  key={index}
                  className={clsx(
                    'border-b border-gray-700 py-2 pr-2 text-left !font-bold text-white'
                  )}
                >
                  {cell}
                </th>
              ))}
            </tr>
          </thead>
        )}
        <tbody>
          {dataRows.map((row, rowIndex) => (
            <tr
              key={row._key || rowIndex}
              className={clsx('border-b border-gray-700 last:border-0')}
            >
              {row.cells.map((cell, cellIndex) => (
                <td key={cellIndex} className={clsx('py-2 pr-2 text-left')}>
                  {cell}
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  )
}
